import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import { BannerDetails_banner_collection } from "@saleor/banners/types/BannerDetails";
import CardTitle from "@saleor/components/CardTitle";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import StatusLabel from "@saleor/components/StatusLabel";
import TableHead from "@saleor/components/TableHead";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
export interface BannerCollectionsProps {
  collection: BannerDetails_banner_collection;
  onCollectionAssign?: () => void;
  onCollectionUnassign?: (id: string) => void;
  disabled?: boolean;
  onRowClick: (id: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    buttonDisabled: {
      "& > span": {
        color: "#616161"
      }
    },
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colEmpty: {
      width: "1px"
    },
    colName: {
      paddingLeft: 0,
      width: 230
    },
    colNameLabel: {},
    colPrice: {
      textAlign: "center",
      width: 100
    },
    colPublished: {
      width: 150
    },
    colSKU: {
      "@media (min-width: 769px)": {
        wordBreak: "break-all"
      },
      width: 150
    },
    colType: {
      width: 150
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "BannerCollections" }
);

const numberOfColumnsVoucher = 4;

const BannerCollections: React.FC<BannerCollectionsProps> = props => {
  const {
    collection,
    onCollectionAssign,
    onCollectionUnassign,
    disabled
    // onRowClick
  } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  function showProductTable() {
    const collectionData = collection ? [collection] : [];

    return (
      <ResponsiveTable className={classes.table}>
        <colgroup>
          <col className={classes.colName} />
          <col className={classes.colType} />
          <col className={classes.colActions} />
        </colgroup>
        <TableHead
          colSpan={numberOfColumnsVoucher}
          disabled={false}
          hideCheckBox
          items={[collection]}
          toolbar={toolbar}
        >
          <TableCell className={classes.colName}>
            <span className={classes.colNameLabel}>
              <FormattedMessage defaultMessage="Collection Name" />
            </span>
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="No. of Products" />
          </TableCell>
          <TableCell className={classes.colPublished}>
            <FormattedMessage
              defaultMessage="Visibility Status"
              description="collection is published"
            />
          </TableCell>
          <TableCell className={classes.colActions} />
        </TableHead>
        <TableBody>
          {renderCollection(
            collectionData,
            (collection, index) => (
              <TableRow
                hover={!!collection}
                key={collection ? collection.id : "skeleton"}
                className={classes.tableRow}
              >
                <TableCell
                  className={classes.colName}
                  id={`collectionNameRow${index}`}
                >
                  {maybe<React.ReactNode>(() => collection.name, <Skeleton />)}
                </TableCell>
                <TableCell
                  className={classes.colType}
                  id={`collectionCountRow${index}`}
                >
                  {maybe<React.ReactNode>(
                    () => collection.products.totalCount,
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell
                  className={classes.colPublished}
                  id={`collectionStatusRow${index}`}
                >
                  {collection && collection.isPublished !== undefined ? (
                    <StatusLabel
                      label={
                        collection.isPublished
                          ? intl.formatMessage({
                              defaultMessage: "Published",
                              description: "product is published"
                            })
                          : intl.formatMessage({
                              defaultMessage: "Not published",
                              description: "product is not published"
                            })
                      }
                      status={collection.isPublished ? "success" : "error"}
                    />
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell
                  className={classes.colActions}
                  id={`collectionUnassignBtnRwo${index}`}
                >
                  <IconButton
                    disabled={!collection}
                    onClick={event => {
                      event.stopPropagation();
                      onCollectionUnassign(collection.id);
                    }}
                  >
                    <DeleteIcon color="primary" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={numberOfColumnsVoucher}>
                  <FormattedMessage defaultMessage="Click Assign Collection to add a featured collection in this list" />
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </ResponsiveTable>
    );
  }

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Featured Collection",
          description: "section header"
        })}
        toolbar={
          <Button
            id="assignCollectionBtn"
            disabled={!!collection || disabled}
            color="primary"
            className={!!collection || disabled ? classes.buttonDisabled : null}
            onClick={onCollectionAssign}
          >
            <FormattedMessage
              defaultMessage="Assign collection"
              description="button"
            />
          </Button>
        }
      />
      {showProductTable()}
    </Card>
  );
};
BannerCollections.displayName = "BannerCollections";
export default BannerCollections;
